import { Navigate } from 'react-router';
import { useLocale } from '../i18n/locale-context';
import { localePath } from '../i18n/locale-path';

/**
 * `/app/saved` is retired — its list-with-two-buttons job moved to the catalog
 * CTA and the builder.
 *
 * It redirects rather than 404ing because a live Telegram command shipped this
 * URL in messages that have ALREADY been delivered; those links cannot be
 * recalled. And it resolves the target through `localePath` because the route
 * tree mounts twice (bare ru, and under `/uz`) — a fixed target would drop an
 * Uzbek visitor out of Uzbek on a link the bot sent them.
 *
 * Targets the HOME route, not `/catalog`: verified on the live prod vhost —
 * `location = /catalog { return 301 /$is_args$args; }` (and the `/uz` twin) —
 * the home IS the catalog, so a `/catalog` target would just cost every
 * recipient of an already-delivered link an extra redirect hop for nothing.
 *
 * Mounted OUTSIDE `<Protected>` in app.tsx: an already-delivered Telegram link
 * must resolve even for a recipient who is signed out on the device they tap
 * it from — the home is fully public, and there is no reason to bounce a
 * guest to `/login` first just because the URL happens to start with `/app`.
 */
export function SavedRedirect() {
  const { locale } = useLocale();
  return <Navigate to={localePath('/', locale)} replace />;
}
